export default __webpack_public_path__ + "static/zinc_prices-4762ee0142d8d40c627420da23146cc1.png";